import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IInvite } from '@/contracts/system-modules/groups/IInvite'

export class GetInvitesRoute extends GroupsRoute<null, IInvite[]> {
  constructor(private readonly groupUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid + '/invites'
  }

  /** Без сервера инвайтов нет */
  offline(): Promise<ApiResponse<IInvite[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
